import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import Body from 'ui/Typography/Body';
import Box from 'ui/Box';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';

export const ModalBox = styled(Box)`
  max-width: ${rem('848px')};
  display: flex;
  flex-direction: column;
`;

export const TopBox = styled.div`
  margin-bottom: ${({ theme }) => theme.space.l};
`;

export const BottomBox = styled.div`
  display: flex;
  align-items: center;
`;

export const IllustrationBox = styled.div`
  padding: 0 ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.xl} 0;
  flex: 3 3 0;
`;

type IllustrationProps = {
  caption?: string;
  image: any;
};

export const Illustration = ({ caption, image: Image }: IllustrationProps) => {
  return (
    <IllustrationBox>
      <Image />
      {caption && (
        <Body mt="md" type={ThemeFontStyleTypeEnum.bodyMedium} italic>
          {caption}
        </Body>
      )}
    </IllustrationBox>
  );
};
